import React, { useEffect, useRef, useState } from "react";
import { Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { LoginApi } from "../../api/request/users";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import Message from "../../assets/auth/Message.jsx";
import Lock from "../../assets/auth/Lock.jsx";
import { setCookies } from "../../services/Cookies.jsx";
import { useDispatch } from "react-redux";
import { setloggedIn, setUserDetails } from "../../store/Slices/userSlice.js";
import { IpProvider } from "../../services/IpProvider.js";

function Login() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: "", password: "", });
  const [ipAddress, setIpAddress] = useState('');

  const getIpAddress = async () => {
    try {
      const { data } = await IpProvider();
      setIpAddress(data?.ip);
    } catch (error) { }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;
    if (!email || !password) {
      toast.error("Email or password can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        ...formData,
        platformName: "user",
        ipAddress: ipAddress
      };
      const { data } = await LoginApi(params);
      if (data?.success) {
        toast.success(data?.message);
        if (data?.data?.mpinSetupRequired) {
          localStorage.setItem("userId", data?.data?.userId);
          navigate("/set-mpin");
        } else if (data?.data?.mpinRequired) {
          localStorage.setItem("userId", data?.data?.userId);
          navigate("/mpin");
        } else if (data?.data?.verifyWithOpt) {
          localStorage.setItem("userId", data?.data?.userId);
          navigate("/otp");
        } else {
          setCookies('token', data?.data?.access_token);
          dispatch(setloggedIn(true));
          let user = data?.data;
          delete user?.access_token;
          dispatch(setUserDetails(user));
          localStorage.clear('userId');
          navigate("/dashboard");
        }
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Something went wrong");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getIpAddress();
  }, []);

  return (
    <div className="auth-page">
      <form autoComplete="off" onSubmit={handleSubmit}>
        <div className="w-full text-sm py-1">
          <p className="text-[#585F70] font-semibold ">Email</p>
          <div className="relative">
            <Form.Item type="email" name="emailId">
              <Input
                placeholder="Enter your email-id"
                className="border rounded-lg w-full ps-3 py-2"
                prefix={<Message />}
                onChange={handleChange}
                name="email"
                value={formData.email}
                defaultValue={formData.email}
              />
            </Form.Item>
          </div>
        </div>
        <div className="w-full text-sm font-normal py-1 mt-3">
          <p className="text-[#585F70] font-semibold">Password</p>
          <div div className="relative">
            <Form.Item name="password">
              <Input.Password
                placeholder="Enter your password"
                className="border rounded-lg w-full ps-3 py-2"
                prefix={<Lock />}
                name="password"
                onChange={handleChange}
                value={formData.password}
                defaultValue={formData.password}
              />
            </Form.Item>
          </div>
        </div>
        <div className="flex justify-end w-full text-sm font-normal">
          <Link
            to="/forget_password"
            className="font-semibold text-xs primary cursor-pointer"
          >
            Forgot Password?
          </Link>
        </div>
        <div className="mt-5">
          <LoadableButton
            type="submit"
            className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text"
            lable="Login"
            isLoading={isLoading}
            loadingLable="Loging in..."
          />
        </div>
        <div className="text-center text-sm mt-4">
          <p>Don't have an account? <Link to="?tab=register" className="primary underline">sign up</Link></p>
        </div>
      </form>
    </div>
  );
}
export default Login;
